// extracted by mini-css-extract-plugin
module.exports = {"PageContent":"PageContent_PageContent__1ccBl","Container":"PageContent_Container__21kY_"};